<template>
    <div>
        <Title title="小区人员出入情况统计" style="position:relative">
            <!-- <div class="totalNum">总人次：{{ totalNum }}次</div> -->
            <Echarts 
                :options="polar"
                style="width: 100%;height: 100%"
                autoresize
                v-if="ifShowEcharts"/>
        </Title>
    </div>    
</template>
<script>
import miment from 'miment';
import Echarts from "vue-echarts";
// 引入曲线图
require("echarts/lib/chart/line");
// 引入提示框和标题组件
require("echarts/lib/component/tooltip");
require("echarts/lib/component/title");
require("echarts/lib/component/grid");
require("echarts/lib/component/legendScroll");
require("echarts/lib/component/dataZoom");
import Title from './title'
export default {
    components: { Title,Echarts },
    data(){
        return {
            totalNum: 0,
            ifShowEcharts: false,
            polar:  {
                tooltip: {
                    trigger: "axis"
                },
                legend: {
                    data: [
                        "居民出",
                        "居民入",
                        "工作出",
                        "工作入"
                    ],
                    top: "8",
                    right: 0,
                    textStyle: {
                        color: '#949a98'
                    }
                },
                grid: {
                    left: "0",
                    right: "0",
                    bottom: "15",
                    top: "50",
                    containLabel: true
                },
                xAxis: {
                    type: "category",
                    data: [],
                    axisTick: {
                        show: false
                    },
                    axisLine: {
                        color: "#959a9e"
                    },
                    axisLabel: {
                        color: "#959a9e",
                        interval: 0,
                        rotate: 30
                    },
                    splitLine: {
                        show: false
                    }
                },
                yAxis: {
                    type: "value",
                    axisTick: {
                        show: false
                    },
                    axisLine: {
                        color: "#959a9e"
                    },
                    axisLabel: {
                        color: "#959a9e"
                    },
                    splitLine: {
                        show: false
                    }
                },
                dataZoom: [
                    {
                        type: "inside",
                        startValue: 0,
                        endValue: 10
                    }
                ],
                series: [
                    {
                        name: "居民出",
                        type: "line",
                        smooth: true,
                        prop: "userOutCount",
                        barWidth: 22,
                        itemStyle: {
                            color: "#34d494"
                        },
                        data: []
                    },
                    {
                        name: "居民入",
                        type: "line",
                        smooth: true,
                        prop: "userInCount",
                        barWidth: 22,
                        itemStyle: {
                            color: "#4058de"
                        },
                        data: []
                    },
                    {
                        name: "工作出",
                        type: "line",
                        smooth: true,
                        prop: "workerOutCount",
                        barWidth: 22,
                        itemStyle: {
                            color: "#f92b2d"
                        },
                        data: []
                    },
                    {
                        name: "工作入",
                        type: "line",
                        smooth: true,
                        prop: "workerInCount",
                        barWidth: 22,
                        itemStyle: {
                            color: "#ffc009"
                        },
                        data: []
                    }
                ]
            }
        }
    },
    props: {
        date: {
            type: String
        }
    },
    methods: {
        // 获取信息
        async getInfo(starttime,endtime){
            let res = await this.$get(this.urlobj.getEpidemicWalk,{
                communityId: this.$route.query.communityId || this.$store.state.streetorcommunityid,
                beginTime: starttime,
                endTime: endtime
            })
            this.polar.xAxis.data = res.rows.map(item => {
                this.totalNum += Number(item.userInCount) + Number(item.userOutCount) + Number(item.workerInCount) +Number(item.workerOutCount);
                return  `${ item.dateTime.split('-')[1] }-${ item.dateTime.split('-')[2] }`
            })
            this.polar.dataZoom[0].endValue = res.rows.length - 1;
            this.polar.dataZoom[0].startValue = res.rows.length - 15;
            let list = [ "userInCount", "userOutCount", "workerInCount","workerOutCount" ]
            list.forEach(item => {
                this.polar.series.find(citem => citem.prop == item).data = res.rows.map(citem => citem[item]);
            })
            this.ifShowEcharts = true;
        }
    },
    watch: {
        date(newVal){
            let starttime,endtime

            if(newVal == '日期选择'){
                this.getInfo();
                return
            }
            if(newVal.length == 6){
                let year = newVal.substring(0,4);
                let month = newVal.substring(4);
                starttime = miment(year + '-' + month + '-' + '01').format('YYYY-MM-DD');
                endtime = miment(year + '-' + month + '-' + new Date(year,month,0).getDate()).format('YYYY-MM-DD');
            
                this.ifShowEcharts = false;
                this.getInfo(starttime,endtime)
            }else if(newVal.length == 8){
                let year = newVal.substring(0,4);
                let month = newVal.substring(4,6);
                let date = newVal.substring(6,7);
                starttime = miment(year + '-' + month + '-' + date).format('YYYY-MM-DD');
                endtime = miment(year + '-' + month + '-' + date).format('YYYY-MM-DD');
            
                this.ifShowEcharts = false;
                this.getInfo(starttime,endtime)
            }
        }
    },
    created(){
        this.getInfo();
    }
}
</script>
<style lang="less" scoped>
.totalNum {
    position: absolute;
    top: 48px;
    left: 20px;
    color: #fcfffd;
    font-size: 12px;
}

</style>